<section *ngIf="candidateData" class="section section-sm">
    <div class="container">

        <app-alert-message *ngIf="authService.isCandidate() && candidateData.status==='pending'" [alertOption]="1"></app-alert-message>
        <app-alert-message *ngIf="authService.isCandidate() && candidateData.status==='disapproved'" [alertOption]="2"></app-alert-message>

        <div class="layout-2">
            <div class="layout-2-item layout-2-item-main">
                <!-- Profile Light-->
                <article style="max-width: 5000px;" class="profile-light">
                    <img *ngIf="avatar" class="profile-light-image" [src]="candidateData.image" alt="" width="169" height="169" />
                    <img *ngIf="!avatar" class="profile-light-image" src="https://upload.wikimedia.org/wikipedia/commons/7/7e/Circle-icons-profile.svg" alt="" width="169" height="169" />
                    <div class="profile-light-main">
                        <h4 class="profile-light-name">{{candidateData.firstName}} {{candidateData.lastName}}</h4>
                        <div class="profile-light-divider"></div>
                        <h5 class="profile-light-position">{{candidateData.headline}}</h5>
                        <br />
                    </div>
                </article>
            </div>

            <div class="layout-2-item text-center text-lg-left">
                <div>
                    <div *ngIf="candidateData && candidateData.cvId" class="group group-xl group-middle">
                        <a style="margin-right: 80px;" class="button button-lg button-primary-outline" (click)="downLoadCv(candidateData.keycloakId)" [href]="fileUrl">
                            <i class="fa fa-download"></i> Βιογραφικο σημειωμα</a>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <section class="section section-md">
        <div class="container">
            <div class="row row-50">
                <div class="col-lg-8">
                    <div class="row row-50">

                        <!-- general info -->
                        <div class="col-12 pFontSize">
                            <p class="heading-9">Γενικα Στοιχεια</p>
                            <hr>
                            <p *ngIf="candidateData.gender==='female'"><span style="color:#6f5f5f">Φύλο:</span> Γυναίκα
                            </p>
                            <p *ngIf="candidateData.gender==='male'"><span style="color:#6f5f5f">Φύλο:</span> Άνδρας
                            </p>
                            <p *ngIf="candidateData.currentEmploymentType==='unemployed'"><span style="color:#6f5f5f">Τρέχουσα Κατάσταση Απασχόλησης:</span> Άνεργος</p>
                            <p *ngIf="candidateData.currentEmploymentType==='part_time'"><span style="color:#6f5f5f">Τρέχουσα Κατάσταση Απασχόλησης:</span>  Μερική Απασχόληση</p>
                            <p *ngIf="candidateData.currentEmploymentType==='full_time'"><span style="color:#6f5f5f">Τρέχουσα Κατάσταση Απασχόλησης:</span>Πλήρης Απασχόληση </p>
                            <p *ngIf="candidateData.afm"><span style="color:#6f5f5f">ΑΦΜ:</span> {{candidateData.afm}}
                            </p>
                            <p *ngIf="candidateData.birthDate"><span style="color:#6f5f5f">Ημ/νια γέννησης:</span> {{candidateData.birthDate|date: 'longDate'}}
                            </p>
                            <p *ngIf="candidateData.birthplace"><span style="color:#6f5f5f">Τόπος γέννησης:</span> {{candidateData.birthplace}}
                            </p>
                            <p *ngIf="candidateData.maritalStatus==='married'"><span style="color:#6f5f5f">Οικογενειακή
                                    κατάσταση:</span>Έγγαμος </p>
                            <p *ngIf="candidateData.maritalStatus==='unmarried'"><span style="color:#6f5f5f">Οικογενειακή κατάσταση:</span>  Άγαμος</p>
                            <p *ngIf="candidateData.maritalStatus==='divorced'"><span style="color:#6f5f5f">Οικογενειακή κατάσταση:</span> Διαζευμένος</p>
                            <p *ngIf="candidateData.numberOfChildren>0"><span style="color:#6f5f5f">Παιδιά:</span> {{candidateData.numberOfChildren}}
                            </p>
                            <p *ngIf="!candidateData.completedMilitaryService && candidateData.gender==='male'">
                                Μη εκπληρωμένες στρατιωτικές υποχρεώσεις </p>
                            <p *ngIf="candidateData.completedMilitaryService"><span style="color:#6f5f5f"><i
                                        class="fa fa-check" aria-hidden="true"></i></span> Εκπληρωμένες στρατιωτικές υποχρεώσεις
                            </p>
                        </div>

                        <!-- contact info -->
                        <div class="col-12 pFontSize">
                            <p class="heading-9">Στοιχεια επικοινωνιας</p>
                            <hr>
                            <p *ngIf="candidateData.phoneNumber">
                                <a class="icon icon-xxs icon-filled icon-filled-brand icon-circle fa fa-phone" style="background: #ca5217; font-size: 10px; color: #ffffff;"></a>
                                <a href="tel:+{{candidateData.phoneNumber}}">&nbsp;+30
                                    {{candidateData.phoneNumber}}</a>
                            </p>
                            <p *ngIf="candidateData.cellphone">
                                <a class="icon icon-xxs icon-filled icon-filled-brand icon-circle fa fa-mobile" style="background: #ca5217; font-size: 10px; color: #ffffff;"></a>
                                <a href="tel:+{{candidateData.cellphone}}">&nbsp;+30 {{candidateData.cellphone}}</a>
                            </p>
                            <p *ngIf="candidateData.linkedInUrl">
                                <a class="icon icon-xxs icon-filled icon-filled-brand icon-circle fa fa-linkedin" style="background: #5776b7; font-size: 10px;" href={{candidateData.linkedInUrl}}></a>
                                <a href="{{candidateData.linkedInUrl}}">&nbsp;{{candidateData.linkedInUrl}}</a>
                            </p>
                            <p *ngIf="candidateData.email">
                                <a class="icon icon-xxs icon-filled icon-filled-brand icon-circle fas fa-envelope" style="background: #ca5217; font-size: 10px; color: #ffffff;"></a>
                                <a href="mailto:{{candidateData.email}}">&nbsp;{{candidateData.email}}</a>
                            </p>
                            <p *ngIf="candidateData.facebookUrl">
                                <a class="icon icon-xxs icon-filled icon-filled-brand icon-circle fa fa-facebook" style="font-size: 10px;" href={{candidateData.facebookUrl}}></a>
                                <a href="{{candidateData.facebookUrl}}">&nbsp;{{candidateData.facebookUrl}}</a>
                            </p>
                            <p *ngIf="candidateData.fax">
                                <a class="icon icon-xxs icon-filled icon-filled-brand icon-circle fa fa-fax" style="background: #ca5217; font-size: 10px; color: #ffffff;"></a>
                                <a href="fax:{{candidateData.fax}}">&nbsp;{{candidateData.fax}}</a>
                            </p>
                            <div>
                                <p style="margin-top: 5%;" *ngIf="candidateData.address">
                                    <!-- <a class="icon icon-xxs icon-filled icon-filled-brand icon-circle mdi mdi-map-marker" style="background: #ca5217; font-size: 10px; color: #ffffff;"></a> -->
                                    <span style="color:#ca5217;" class="icon icon-1 text-primary mdi mdi-map-marker"></span> <span style="color:#6f5f5f"> Διεύθυνση κατοικίας: </span> {{candidateData.address}} {{candidateData.city}} {{candidateData.postcode}}
                                </p>
                                <p *ngIf="candidateData.prefecture_id"><span style="color:#ca5217; font-size: 12px;" class="icon icon-1 text-primary mdi mdi-map-marker-circle"></span> <span style="color:#6f5f5f"> Νομός: </span>{{candidateData.prefecture_name}}</p>
                            </div>
                        </div>

                        <!-- Cv info -->
                        <div class="col-12 pFontSize">
                            <p class="heading-9">Στοιχεια βιογραφικου</p>
                            <hr>

                            <p *ngIf="candidateData.yearsOfWorkExperience>0"><span style="color:#6f5f5f">Προϋπηρεσία:
                                </span>{{candidateData.yearsOfWorkExperience}} χρόνια</p>
                            <p *ngIf="candidateData.educationLvlId"><span style="color:#6f5f5f">Βαθμίδα
                                    εκπαίδευσης:</span> {{candidateData.educationLvlName}}</p>
                            <p *ngIf="candidateData.hasComputerSkills"><span style="color:#6f5f5f"><i
                                        class="fa fa-check" aria-hidden="true"></i></span> Γνώσεις Η/Υ</p>
                            <p *ngIf="candidateData.hasUnemploymentCard"><span style="color:#6f5f5f"><i
                                        class="fa fa-check" aria-hidden="true"></i></span> Κάρτα ανεργίας από ΟΑΕΔ</p>
                            <p *ngIf="candidateData.hasSpecialNeeds">Άτομο με ειδικές ανάγκες</p>
                        </div>


                        <!-- Work experience -->
                        <div *ngIf="experience && experience.length > 0 && experience[0].company" class="col-12">
                            <p class="heading-9">Επαγγελματικη Εμπειρια</p>
                            <hr>
                            <div class="timeline-classic">
                                <div *ngFor="let content of experience" class="timeline-classic-item">
                                    <div class="timeline-classic-period">
                                        <span style="font-size: 15px">{{content.yearStart}}–{{content.yearEnd}}</span>
                                    </div>
                                    <div class="timeline-classic-main">
                                        <h5 class="timeline-classic-title">{{content.role}}</h5>
                                        <p class="pFontSize"><span style="color:#6f5f5f">Επωνυμία Εταιρείας:
                                            </span>{{content.company}}
                                        </p>
                                        <p class="pFontSize"><span style="color:#6f5f5f">Σχέση Απασχόλησης:
                                            </span>{{content.employmentTypesName}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- education -->
                        <div *ngIf="education && education.length > 0" class="col-12">
                            <p class="heading-9">Εκπαιδευση</p>
                            <hr>
                            <div class="timeline-classic">
                                <div *ngFor="let ed_content of education" class="timeline-classic-item">
                                    <div *ngIf="ed_content.yearStart || ed_content.yearEnd" class="timeline-classic-period">
                                        <span style="font-size: 15px">{{ed_content.yearStart}}-{{ed_content.yearEnd}}</span>
                                    </div>
                                    <div *ngIf="ed_content.university || ed_content.degree" class="timeline-classic-main">
                                        <h5 class="timeline-classic-title">{{ed_content.degree}}
                                        </h5>
                                        <p class="pFontSize" *ngIf="ed_content.educationLvlName"><span style="color:#6f5f5f">Βαθμίδα
                                                Εκπαίδευσης: </span>{{ed_content.educationLvlName}}</p>
                                        <p class="pFontSize" *ngIf="ed_content.university"><span style="color:#6f5f5f">Εκπαιδευτικό
                                                Ίδρυμα: </span>{{ed_content.university}}</p>
                                        <p class="pFontSize" *ngIf="ed_content.degree_rate"><span style="color:#6f5f5f">Βαθμός Πτυχίου:
                                            </span>{{ed_content.degree_rate}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Languages -->
                        <div *ngIf="candidateLanguages && candidateLanguages.length > 0" class="col-12">
                            <p class="heading-9">Ξενες Γλωσσες</p>
                            <hr>
                            <div class="timeline-classic">
                                <div *ngFor="let content of candidateLanguages" class="timeline-classic-item">
                                    <div *ngIf="content.degreeTitle || content.languageId" class="timeline-classic-main">
                                        <h5 class="timeline-classic-title">{{content.degreeTitle}}</h5>
                                        <p class="pFontSize" *ngIf="content.languageId"><span style="color:#6f5f5f">Γλώσσα:</span> {{content.languageName}}
                                        </p>

                                        <p class="pFontSize" *ngIf="content.degreeLevel && content.degreeLevel==='basic'"><span style="color:#6f5f5f">Επίπεδο:</span> Βασικός Χρήστης</p>
                                        <p class="pFontSize" *ngIf="content.degreeLevel && content.degreeLevel==='proficient'"><span style="color:#6f5f5f">Επίπεδο:</span> Ικανός Χρήστης</p>
                                        <p class="pFontSize" *ngIf="content.degreeLevel && content.degreeLevel==='independent'"><span style="color:#6f5f5f">Επίπεδο:</span> Ανεξάρτητος Χρήστης</p>

                                        <p class="pFontSize" *ngIf="content.comments"><span style="color:#6f5f5f">Σχόλια</span> {{content.comments}}
                                        </p>
                                    </div>
                                </div>
                                <!-- <div *ngIf="candidateLanguages && candidateLanguages.length === 0"> - </div> -->
                            </div>
                        </div>

                        <!-- Seminars -->
                        <div *ngIf="seminars && seminars.length > 0" class="col-12">
                            <p class="heading-9">Επιμορφωση / Σεμιναρια</p>
                            <hr>
                            <div class="timeline-classic">
                                <div *ngFor="let content of seminars" class="timeline-classic-item">
                                    <div *ngIf="content.organisation || content.programTitle" class="timeline-classic-main">
                                        <h5 class="timeline-classic-title">{{content.programTitle}}</h5>
                                        <p class="pFontSize" *ngIf="content.organisation"><span style="color:#6f5f5f">Οργανισμός ή Φορέας
                                                Επιμόρφωσης: </span>{{content.organisation}}</p>
                                        <p class="pFontSize" *ngIf="content.programDuration"><span style="color:#6f5f5f">Διάρκεια
                                                προγράμματος: </span>{{content.programDuration}}</p>
                                        <p class="pFontSize" *ngIf="content.isCertificated"><span style="color:#6f5f5f"><i
                                                    class="fa fa-check" aria-hidden="true"></i></span> Βεβαίωση Παρακολούθησης
                                        </p>

                                        <p class="pFontSize" *ngIf="content.comments"><span style="color:#6f5f5f">Σχόλια:
                                            </span>{{content.comments}}</p>
                                    </div>
                                </div>
                                <!-- <div *ngIf="seminars && seminars.length === 0"> - </div> -->
                            </div>
                        </div>

                        <!-- more info -->
                        <div *ngIf="candidateData.participations || candidateData.accomplishments || candidateData.volunteer_work || candidateData.computerPrograms || candidateData.personalInterests" class="col-12">
                            <p class="heading-9">Επιπλεον πληροφοριες</p>
                            <hr>
                            <div class="timeline-classic">

                                <div *ngIf="candidateData.participations" class="timeline-classic-item">
                                    <div class="timeline-classic-main">
                                        <h5>Συμμετοχη σε οργανωσεις, φορεις, ομιλους ή ομαδες</h5>
                                        <p id="moreInfoParagraph" class="text-style-1" [innerHtml]="candidateData.participations | safe"></p>
                                    </div>
                                </div>

                                <div *ngIf="candidateData.accomplishments" class="timeline-classic-item">
                                    <div class="timeline-classic-main">
                                        <h5>Συνεδρια, ομιλιες, ημεριδες ή παρουσιασεις</h5>
                                        <p id="moreInfoParagraph" class="text-style-1" [innerHtml]="candidateData.accomplishments | safe"></p>
                                    </div>
                                </div>

                                <div *ngIf="candidateData.volunteer_work" class="timeline-classic-item moreInfoParagraph">
                                    <div class="timeline-classic-main">
                                        <h5>Εθελοντικη εργασια</h5>
                                        <p id="moreInfoParagraph" class="text-style-1" [innerHtml]="candidateData.volunteer_work | safe"></p>
                                    </div>
                                </div>

                                <div *ngIf="candidateData.computerPrograms" class="timeline-classic-item moreInfoParagraph">
                                    <div class="timeline-classic-main">
                                        <h5>Γνωσεις προγραμματων Η/Υ</h5>
                                        <p id="moreInfoParagraph" class="text-style-1" [innerHtml]="candidateData.computerPrograms | safe"></p>
                                    </div>
                                </div>

                                <div *ngIf="candidateData.personalInterests" class="timeline-classic-item moreInfoParagraph">
                                    <div class="timeline-classic-main">
                                        <h5>Προσωπικα ενδιαφεροντα</h5>
                                        <p id="moreInfoParagraph" class="text-style-1" [innerHtml]="candidateData.personalInterests | safe"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br /><br />
                    </div>
                </div>

                <div class="col-lg-4 form-corporate">
                    <div *ngIf="candidateData.keycloakId === this.authService.getCandidateKeycloakId()">
                        <div>
                            <a [routerLink] = "['/candidates/applied-job-list']"><button style=" margin-bottom: 10%;" class="button button-block button-primary">οι
                                αιτησεις μου</button>
                            </a>
                            <a [routerLink] = "['/candidates/complete-profile']">
                            <button class="button button-block button-primary">Επεξεργασια
                                Προφιλ</button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>